import { useFormContext } from 'react-hook-form';
import type { IGetNotificationPreferencesServiceResData } from '../../../../api/Notification/types';
import type { INotificationPreferenceTypes, NotificationPreferencesForm } from '../types';
import { Toggle } from './Toggle';

interface INotificationPreferencesGroupProps {
  data: IGetNotificationPreferencesServiceResData;
  currentTab: string;
}

const NotificationPreferencesGroup = ({ data, currentTab }: INotificationPreferencesGroupProps) => {
  const { getValues, setValue } = useFormContext<NotificationPreferencesForm>();

  return (
    <div className='grid grid-cols-4 gap-4 border-b-2 py-4'>
      <h4 className='font-semibold'>{data.notificationGroup}</h4>

      <div className='col-span-3 divide-y-2'>
        {data?.notifications?.map((ntfGroup) => {
          return (
            <div key={ntfGroup.slug} className='flex justify-between py-4 gap-4'>
              <div>
                <h4 className='mb-2 font-semibold'>{ntfGroup?.name}</h4>
                <small className='text-sm text-gray-500'>
                  {ntfGroup?.description} {!ntfGroup.canBeTurnedOff && <span>(It cannot be turned off)</span>}
                </small>
              </div>

              <div className='flex justify-center gap-2 items-center'>
                {ntfGroup?.types
                  ?.sort((a: INotificationPreferenceTypes, b: INotificationPreferenceTypes) => a.name.localeCompare(b.name))
                  ?.map((type: INotificationPreferenceTypes) => (
                    <Toggle
                      key={type.slug}
                      currentTab={currentTab}
                      data={data}
                      notificationGroup={ntfGroup}
                      type={type}
                      getValues={getValues}
                      setValue={setValue}
                    />
                  ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NotificationPreferencesGroup;
